module.exports = __webpack_public_path__ + "img/4.423521c4.jpg";